<template>
  <section class="section-form">
    <div class="div-color"></div>
    <div class="container">
      <div class="section-f-cont">
        <div class="form-card-div">
          <h1>{{ $tc('home_page.contact_form_home_h1') }}</h1>

          <ContactForm />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContactForm from './ContactForm'

export default {
  components: {
    ContactForm
  }
}
</script>
